import script from "./highKYN28.vue?vue&type=script&setup=true&lang=js"
export * from "./highKYN28.vue?vue&type=script&setup=true&lang=js"

import "./highKYN28.vue?vue&type=style&index=0&id=9d5356b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d5356b2"]])

export default __exports__